import React from 'react';
import DatePicker from 'react-datepicker';

import CustomInput from './CustomInput/CustomInput';
import CustomHeader, { Props as CustomHeaderProps } from './CustomHeader/CustomHeader';
import { buildDayClassName } from './helpers';

import './styles.css';

export interface Props {
  isDisabled?: boolean;
  onChange: (selectedDate: Date) => void;
  selectableDates?: Date[];
  selectedDatetime?: Date;
}

const customHeaderRenderer = ({
  date,
  decreaseMonth,
  increaseMonth,
  nextMonthButtonDisabled,
  prevMonthButtonDisabled,
}: CustomHeaderProps) => (
  <CustomHeader
    date={date}
    decreaseMonth={decreaseMonth}
    increaseMonth={increaseMonth}
    nextMonthButtonDisabled={nextMonthButtonDisabled}
    prevMonthButtonDisabled={prevMonthButtonDisabled}
  />
);

const SessionDatePicker: React.FC<Props> = ({
  isDisabled = false,
  onChange,
  selectableDates,
  selectedDatetime,
}) => (
  <DatePicker
    calendarClassName="border-none shadow-lg font-sans"
    customInput={<CustomInput isDisabled={isDisabled} selectedDatetime={selectedDatetime} />}
    dayClassName={(date) => buildDayClassName({ date, selectedDatetime })}
    disabled={isDisabled}
    disabledKeyboardNavigation
    includeDates={selectableDates}
    monthClassName={() => 'px-2 pb-2'}
    onChange={onChange}
    popperProps={{ positionFixed: true }}
    renderCustomHeader={customHeaderRenderer}
    selected={selectedDatetime}
    showPopperArrow={false}
    weekDayClassName={() => 'text-gray-600'}
    wrapperClassName="w-full"
  />
);

export default SessionDatePicker;
